import { render } from "./Subtabla.vue?vue&type=template&id=7e6fd4ee&scoped=true"
import script from "./Subtabla.vue?vue&type=script&lang=js"
export * from "./Subtabla.vue?vue&type=script&lang=js"

import "./Subtabla.vue?vue&type=style&index=0&id=7e6fd4ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e6fd4ee"

export default script